
window.ECV_CONFIGURATION='YKB';
console.log("ECV CONFIGURATION = YKB");
let modules = [
import('../modules/CoreModules/Demo'),
import('../modules/CoreModules/PureWebRTC'),
import('../modules/CoreModules/ExternalAdapter'),
import('../modules/CoreModules/Photo'),
import('../modules/CustomerModules/YKB/YkbHelpers'),
import('../modules/CustomerModules/YKB/YkbAgentOnHoldEvent'),];
export default modules;